import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { BookOpen, Users, Shield } from 'lucide-react';

export const QuickAccessBar = () => {
  const { language } = useLanguage();
  const location = useLocation();

  // Ne pas afficher sur les pages admin ou deal-room
  const hiddenPaths = ['/admin/login', '/admin/dashboard', '/deal-room'];
  if (hiddenPaths.includes(location.pathname)) return null;

  const links = [
    { 
      path: '/book-picsu', 
      icon: BookOpen,
      label: { fr: "Livre", en: "Book", pt: "Livro", it: "Libro", ru: "Книга", zh: "书" },
      color: 'emerald'
    },
    { 
      path: '/scientific-council', 
      icon: Users,
      label: { fr: "Experts", en: "Experts", pt: "Especialistas", it: "Esperti", ru: "Эксперты", zh: "专家" },
      color: 'sky'
    },
    { 
      path: '/validations', 
      icon: Shield,
      label: { fr: "Preuves", en: "Proofs", pt: "Provas", it: "Prove", ru: "Доказ.", zh: "证明" },
      color: 'amber'
    },
  ];

  const colorClasses = {
    emerald: 'bg-emerald-600 hover:bg-emerald-700 shadow-emerald-200',
    sky: 'bg-sky-600 hover:bg-sky-700 shadow-sky-200',
    amber: 'bg-amber-500 hover:bg-amber-600 shadow-amber-200'
  };

  return (
    <div 
      className="fixed right-4 top-1/2 -translate-y-1/2 z-40 hidden lg:flex flex-col gap-3"
      data-testid="quick-access-bar"
    >
      {links.map((link) => (
        <Link
          key={link.path}
          to={link.path}
          data-testid={`quick-access-${link.path.slice(1)}`}
          className={`group flex items-center gap-2 px-3 py-3 rounded-xl text-white transition-all shadow-lg hover:shadow-xl hover:scale-105 ${colorClasses[link.color]} ${
            location.pathname === link.path ? 'ring-2 ring-white ring-offset-2' : ''
          }`}
        >
          <link.icon className="w-5 h-5" />
          <span className="text-xs font-semibold whitespace-nowrap">
            {link.label[language] || link.label.fr}
          </span>
        </Link>
      ))}
    </div>
  );
};
